import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import UploadPage from "./components/UploadPage";
import Results from "./components/Results";

const App = () => {
  const [extractedData, setExtractedData] = useState(null);

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      // Custom warning message
      event.preventDefault();
      event.returnValue = ""; // Some browsers require this to show a warning.
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    // Cleanup on component unmount
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  return (
    <Router>
      <Routes>
        {/* Route for the upload page */}
        <Route
          path="/"
          element={<UploadPage setExtractedData={setExtractedData} />}
        />
        {/* Route for the results page */}
        <Route
          path="/results"
          element={<Results data={extractedData} />}
        />
      </Routes>
    </Router>
  );
};

export default App;
